/**
 *
 *
 *
 *
 *
 */
export function calcScrollPositions(
  items: HTMLElement[],
  containerWidth: number,
  gap: number,
): number[] {
  const scrollPositions: number[] = [0];
  let pos = gap;
  let viewEnd = containerWidth;
  let checkpoint = 0;

  items
    .map((item) => item.getBoundingClientRect().width)
    .forEach((width) => {
      if (pos + width + gap > viewEnd) {
        if (checkpoint > 0) {
          /*                                                            */
          const fixture = (pos - gap - checkpoint - containerWidth) / 2;
          scrollPositions.push(checkpoint + fixture);
        }

        checkpoint = pos;
        viewEnd = pos + containerWidth;
      }
      pos += width + gap;
    });

  if (checkpoint > 0) scrollPositions.push(checkpoint);

  return scrollPositions;
}
